// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Content__Wrapper_fAnjy","ColLeft":"Content__ColLeft_d6Dye","Share":"Content__Share_28_RB"};